import { Card, Flex, Text } from "@mantine/core";
import { AttachmentModel } from "../types/attachment.types";
import { fileIcon, fileSize } from "./Attachment";

import classes from './Attachment.module.css';

interface CommentAttachmentProps {
  attachment: AttachmentModel;
}

export default function CommentAttachment(
  { attachment }: CommentAttachmentProps
) {
  return (
    <Card
      padding={4}
      shadow="xs"
      withBorder={true}
      w="190px"
      component="a"
      href={attachment.path}
      target="_blank"
    >
      <Flex gap={6} align="center">
        {fileIcon(attachment, 'compact')}
        <div style={{ maxWidth: 'calc(100% - 42px)' }}>
          <Text className={classes.fileName} size="sm">
            {attachment.file_name}
          </Text>
          <Text size="xs" c="gray.7">
            {fileSize(attachment.size)}
          </Text>
        </div>
      </Flex>
    </Card>
  )
}